var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-checkout" },
    [
      _vm.hasDivider ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "mb-0" }, [
        _vm._v(_vm._s(_vm.$t("message.booking.summary.discount_and_coins")))
      ]),
      _vm._v(" "),
      _vm.user
        ? _c("promo-code", {
            attrs: {
              creditDiscountCost: _vm.creditDiscountCost,
              totalPrice: _vm.totalPrice
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("label", [
        _vm._v(_vm._s(_vm.$t("message.my_reservations.payment_detail")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-1" }, [
        _c("div", { staticClass: "p-0" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("message.booking.summary.subtotal")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-fill p-0 text-right" }, [
          _vm._v(
            "\n      " + _vm._s(_vm._f("currency")(_vm.subtotal)) + "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.appliedPromoCode && _vm.appliedPromoCode.is_applied
        ? _c("div", { staticClass: "d-flex mb-1" }, [
            _c("div", { staticClass: "p-0" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.promo_code.discount")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-fill p-0 text-right -status-discount" },
              [
                _vm._v(
                  "\n      -" +
                    _vm._s(_vm._f("currency")(_vm.discountCost)) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-1" }, [
        _c("div", { staticClass: "p-0" }, [
          _vm._v(_vm._s(_vm.$t("message.booking.summary.vat")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-fill p-0 text-right" }, [
          _vm._v(
            "\n      " + _vm._s(_vm._f("currency")(_vm.serviceVat)) + "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.preCheckoutData &&
      _vm.preCheckoutData.is_credit &&
      _vm.creditDiscountCost
        ? _c("section", [
            _c("div", { staticClass: "d-flex mb-1" }, [
              _c("div", { staticClass: "p-0" }, [
                _vm._v(_vm._s(_vm.$t("message.booking.summary.coins_discount")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-fill p-0 text-right -status-discount" },
                [
                  _vm._v(
                    "\n        -" +
                      _vm._s(_vm._f("currency")(_vm.creditDiscountCost)) +
                      "\n      "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex pt-2 text-total-price" }, [
              _c("div", { staticClass: "p-0" }, [
                _c("label", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("message.booking.summary.total_price")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-fill p-0 text-right" }, [
                _c("div", { staticClass: "text-primary" }, [
                  _c("label", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice)))
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "d-flex pt-2 text-total-price" }, [
            _c("div", { staticClass: "p-0" }, [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.$t("message.booking.summary.total_price")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-fill p-0 text-right" }, [
              _c("div", { staticClass: "text-primary" }, [
                _c("label", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice)))
                ])
              ])
            ])
          ]),
      _vm._v(" "),
      _c("promo-code-detail-modal", { ref: "promoCodeDetailModal" }),
      _vm._v(" "),
      _c("snackbar", {
        ref: "snackbar",
        attrs: {
          baseSize: "100px",
          colors: {
            open: "#333",
            info: "#3DBD7D",
            error: "#FA7377",
            warn: "#FF6600"
          },
          holdTime: 2500,
          position: "bottom-center"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-710ba416", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710ba416","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/CheckoutCost.vue
// module id = 1800
// module chunks = 0